import { render, staticRenderFns } from "./Usedevice.vue?vue&type=template&id=4b5553f4&scoped=true"
import script from "./Usedevice.vue?vue&type=script&lang=js"
export * from "./Usedevice.vue?vue&type=script&lang=js"
import style0 from "./Usedevice.vue?vue&type=style&index=0&id=4b5553f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5553f4",
  null
  
)

export default component.exports